import http from 'conversations-http/clients/http';
export function fetchContactsById({
  vids
}) {
  return http.get(`/contacts/v1/contact/vids/batch`, {
    query: {
      vid: vids
    }
  });
}